<wbo-bi-filter-page [title]="entityModel.data.name">
    <wbo-page-navs>
        <wbo-page-nav>
            <wbo-bi-page-select-nav></wbo-bi-page-select-nav>
        </wbo-page-nav>
        <wbo-page-nav>
            <fui-nav-button [title]="'wbo.common.button.reset'" (click)="reset()">
                <fui-icon [icon]="'reset'" [height]="12" [width]="12"></fui-icon>
            </fui-nav-button>
        </wbo-page-nav>
    </wbo-page-navs>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="dateRangeRef">
                <wbo-date-range-single-select-search-control [cube]="cubeDefinition?.cubeName"></wbo-date-range-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="[Outlet].[location].[location]">
                <wbo-location-multi-select-search-control></wbo-location-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-bi-filter-extended-fields [cubeDefinition]="cubeDefinition"></wbo-bi-filter-extended-fields>
        </wbo-search-form-extended-fields>
    </wbo-search-form>

    <wbo-bi-server-status-indicator *ngIf="serverStatusModel.isInitialising()"></wbo-bi-server-status-indicator>
    <div class="dashboard-view" *ngIf="serverStatusModel.isInitialised()">
        <wbo-bi-view-page-header [restrictions]="(dashboardModel.dashboardFilter$ | async)?.restrictions"
                                 (reset)="reset()"
                                 (refresh)="refresh()" [showRefresh]="true"
                                 (edit)="edit()" [showEdit]="editable"
                                 (clone)="clone()" [showClone]="clonable"
                                 (delete)="delete()" [showDelete]="deletable">
        </wbo-bi-view-page-header>

        <div class="charts">
            <fui-rows *ngIf="layout">
                <fui-simple-row *ngFor="let r of layout.rows">
                    <fui-column *ngIf="r.columns.length == 1">
                        <div class="chart">
                            <wbo-bi-dashboard-chart (memberSelection)="memberSelected($event)" [chartDef]="r.columns[0]"
                                                    [childHierarchies]="cubeDefinition?.childHierarchies"
                                                    [cubeName]="entityModel.data.cubeName"
                                                    [height]="getChartHeight(r)"></wbo-bi-dashboard-chart>
                        </div>
                    </fui-column>
                    <fui-two-columns *ngIf="r.columns.length == 2">
                        <fui-column *ngFor="let c of r.columns">
                            <div class="chart">
                                <wbo-bi-dashboard-chart (memberSelection)="memberSelected($event)" [chartDef]="c"
                                                        [childHierarchies]="cubeDefinition?.childHierarchies"
                                                        [cubeName]="entityModel.data.cubeName"
                                                        [height]="getChartHeight(r)"></wbo-bi-dashboard-chart>
                            </div>
                        </fui-column>
                    </fui-two-columns>
                    <fui-three-columns *ngIf="r.columns.length == 3">
                        <fui-column *ngFor="let c of r.columns">
                            <div class="chart">
                                <wbo-bi-dashboard-chart (memberSelection)="memberSelected($event)" [chartDef]="c"
                                                        [childHierarchies]="cubeDefinition?.childHierarchies"
                                                        [cubeName]="entityModel.data.cubeName"
                                                        [height]="getChartHeight(r)"></wbo-bi-dashboard-chart>
                            </div>
                        </fui-column>
                    </fui-three-columns>
                    <fui-four-columns *ngIf="r.columns.length == 4">
                        <fui-column *ngFor="let c of r.columns">
                            <div class="chart">
                                <wbo-bi-dashboard-chart (memberSelection)="memberSelected($event)" [chartDef]="c"
                                                        [childHierarchies]="cubeDefinition?.childHierarchies"
                                                        [cubeName]="entityModel.data.cubeName"
                                                        [height]="getChartHeight(r)"></wbo-bi-dashboard-chart>
                            </div>
                        </fui-column>
                    </fui-four-columns>
                </fui-simple-row>
            </fui-rows>
        </div>
    </div>
</wbo-bi-filter-page>
